import React from "react";
import "./Overview.css";
import { Download } from "lucide-react";

const Overview = () => {
  return (
    <>
      <div className="overview-container">
        <h1 className="overview-heading">Overview</h1>

        {/* Overview Form Section */}
        <section className="overview-top">
          <form action="" className="overview-form">
            <div className="overview-form-section">
              <div className="overview-form-input-fields">
                <label>Select Branch</label>
                <select name="" id="">
                  <option value="">Select Branch</option>
                </select>
              </div>
              <div className="overview-form-input-fields">
                <label>Start Date</label>
                <input type="date" />
              </div>
              <div className="overview-form-input-fields">
                <label>End Date</label>
                <input type="date" />
              </div>
              <div className="overview-form-input-fields">
                <label>Select Bank Ledger</label>
                <select name="" id="">
                  <option value="">Select Back Ledger</option>
                </select>
              </div>
            </div>
            <div className="overview-form-submit-btn">
              <button>Get Records</button>
            </div>
          </form>
        </section>

        {/* pdf download buttons */}
        <div className="overview-pdf-download-btns">
          <button>
            <Download size={15}/> Print Cashbook
          </button>
          <button>
            <Download size={15}/> Print Bankbook
          </button>
          <button>
            <Download size={15}/> Print Cashbook & Bankbook
          </button>
        </div>

        {/* Overview Report Section */}
        <section className="overview-report">
          <div className="overview-report-container">
            {/* <p className="overview-report-heading">Cash Records</p> */}
            <div className="overview-report-table">
            <p className="overview-report-heading">Cash Records</p>

              <div className="overview-report-table-div">
                <div className="overview-report-debit-table">
                  <p>Debit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>DR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Debit</td>
                    </tr>
                  </table>
                </div>
                <div className="overview-report-credit-table">
                  <p>Credit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>CR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Credit</td>
                    </tr>
                  </table>
                </div>
              </div>
              <p style={{ textAlign: "center", fontWeight: 600 }}>
                Closing Balance NaN ()
              </p>
            </div>
          </div>
          <div className="overview-report-container">
            {/* <p className="overview-report-heading">Bank Records</p> */}
            <div className="overview-report-table">
            <p className="overview-report-heading">Bank Records</p>

              <div className="overview-report-table-div">
                <div className="overview-report-debit-table">
                  <p>Debit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>DR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Debit</td>
                    </tr>
                  </table>
                </div>
                <div className="overview-report-credit-table">
                  <p>Credit</p>
                  <table>
                    <tr>
                      <th>Particulars</th>
                      <th>CR</th>
                    </tr>
                    <tr>
                      <td>A</td>
                      <td>Credit</td>
                    </tr>
                  </table>
                </div>
              </div>
                <p style={{ textAlign: "center", fontWeight: 600 }}>
                  Closing Balance NaN ()
                </p>
            </div>
          </div>
        </section>

        {/* Overview Bottom Section */}
        <section className="overview-bottom">
          <h1 className="profit-loss-heading">Profit-Loss</h1>
          <div className="overview-bottom-grid">
            <div className="overview-bottom-info-div">
              <h3>Income</h3>
              <p>
                Indirect Income: <span>0</span>
              </p>
            </div>
            <div className="overview-bottom-info-div">
              <h3>Expense</h3>
              <p>
                Indirect Expense: <span>0</span>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Overview;
